import { useState, useEffect } from 'react';
import type { DynamicEntityDefinition } from '../types/DynamicEntity.types';
import { useDynamicEntitiesApi } from './useDynamicEntitiesApi';
import { useDynamicEntitiesContext } from '../DynamicEntitiesProvider';

interface UseDynamicDefinitionResult {
    definition: DynamicEntityDefinition | null;
    loading: boolean;
    error: Error | null;
    reload: () => void;
}

export const useDynamicDefinition = (featureCode: string, entityCode: string): UseDynamicDefinitionResult => {
    const { onError } = useDynamicEntitiesContext();
    const api = useDynamicEntitiesApi();
    const [definition, setDefinition] = useState<DynamicEntityDefinition | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<Error | null>(null);
    const [trigger, setTrigger] = useState(0);

    useEffect(() => {
        let mounted = true;
        setLoading(true);
        setError(null);

        api.getDefinition(featureCode, entityCode)
            .then(data => {
                if (mounted) {
                    setDefinition(data);
                    setLoading(false);
                }
            })
            .catch(err => {
                if (mounted) {
                    setError(err);
                    setLoading(false);
                    if (onError) onError(err);
                }
            });

        return () => {
            mounted = false;
        };
    }, [api, featureCode, entityCode, trigger, onError]);

    const reload = () => setTrigger(prev => prev + 1);

    return { definition, loading, error, reload };
};
